export const flickr = () => (
  <>
    <path
      d="M17.5556 15.8889C20.0102 15.8889 22 13.8991 22 11.4444C22 8.99022 20.0102 7 17.5556 7C15.1009 7 13.1111 8.99022 13.1111 11.4444C13.1111 13.8991 15.1009 15.8889 17.5556 15.8889Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#FF0084"
    />
    <path
      d="M6.44444 15.8889C8.89911 15.8889 10.8889 13.8991 10.8889 11.4444C10.8889 8.99022 8.89911 7 6.44444 7C3.98978 7 2 8.99022 2 11.4444C2 13.8991 3.98978 15.8889 6.44444 15.8889Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#0063DC"
    />
  </>
);
